import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import '../../../../components/Display/Data.scss';
import Section from '../../../../components/Display/Section';
import ImageItem from '../../common/image/ImageItem';
import styles from "../../../../components/Display/Wrapper.module.scss";


function CircumstanceDetail({ circumstance, handleUpdateCircumstance, handleDelete }) {
  const updateCircumstanceActions = [
    {
      onClick: handleUpdateCircumstance,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (circumstance) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette actualité ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(circumstance)
    });
  };

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateCircumstanceActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={circumstance.title} large />
          <Data key="label" label={'Légende'} value={circumstance.description} large />
        </div>
      </Section>
      <Section label="Images">
        <div className="flex flex-wrap gap-5">
          {circumstance.images.map((image) => (
            <ImageItem key={image.id} image={image} className="w-96" />
          ))}
        </div>
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'actualité"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(circumstance)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default CircumstanceDetail;
